import { useMutation } from "@tanstack/react-query";
import { getAuthApiClient } from "@shared/apis/sidekick/api-factories";
import { apiResponseErrorHandler } from "@shared/apis/sidekick/api-error-handler";
import { toast } from "@shared/services/toast";
import { generatePkcePair } from "@shared/utils/pkce";

type Params = {
  email: string;
};

export const useAdminImpersonateUser = () => {
  const api = getAuthApiClient();
  const mutation = useMutation({
    mutationFn: async ({ email }: Params) => {
      const { codeVerifier, codeChallenge } = await generatePkcePair();
      const { redirectUrl } = await api.authControllerAdminImpersonate({
        adminImpersonateRequest: { email, codeChallenge },
      });

      const url = new URL(redirectUrl);
      url.hash = `code_verifier=${encodeURIComponent(codeVerifier)}`;
      return url.toString();
    },
    onError: async (error) => {
      const apiError = await apiResponseErrorHandler(error);
      console.error("Failed to impersonate user.", error);
      if (apiError.status === 403) {
        toast.error("You don't have permission to impersonate users.");
        return;
      }
      toast.error(apiError.errors[0]);
    },
  });

  return mutation;
};
